import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useDispatch } from "react-redux";
import EditApplication from "./EditApplication";
import { ActiveCell } from "../GridComponents";
import { EditCommandCell, SignatureCell } from "../GridComponents";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { editApplication, getApplications } from "actions/application.action";

const ApplicationsList = () => {
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [editItem, setEditItem] = useState(null);
  const enterEdit = (item) => {
    setIsEditFormOpen(true);
    setEditItem(item);
  };

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      await dispatch(
        editApplication(data.appCode, {
          appCode: data.appCode,
          appName: data.appName,
          active: data.active ?? true,
        })
      );
      setIsEditFormOpen(false);
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };
  const applicationsList = useSelector(
    (state) => state.applications.applicationsList
  );
  useEffect(() => {
    if (applicationsList !== null && applicationsList !== undefined) {
      setData(applicationsList);
    }
  }, [applicationsList]);

  useEffect(() => {
    dispatch(getApplications());
  }, []);

  const handleCancelEdit = () => {
    setIsEditFormOpen(false);
    setEditItem(null);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid-wrapper">
      <div className="settings-grid">
        <Grid data={data}>
          <Column title=" " field="appCode" cell={SignatureCell} width="60px" />
          <Column field="appCode" title="App Code" width="120px" />
          <Column field="appName" title="App Name" width="200px" />
          <Column cell={ActiveCell} title="Active" width="50px" />
          <Column title="Edit" cell={MyEditCommandCell} width="40px" />
        </Grid>

        {isEditFormOpen && (
          <EditApplication
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={editItem}
            type="edit"
            isSubmitting={isSubmitting}
          />
        )}
      </div>
    </div>
  );
};

export default ApplicationsList;
